import { StyledEngineProvider } from "@mui/material/styles";
import { StylesProvider } from "@mui/styles";
import App from "App";
import { ThemeContextProvider } from "contexts/ThemeContext";
import ErrorBoundary, {
  ErrorFallback,
} from "global/components/ErrorBoundary/ErrorBoundary";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import * as serviceWorker from "serviceWorker";
import smoothscroll from "smoothscroll-polyfill";
import { store } from "utils/store";

// steps to override default smooth scrolling behaviour in browsers
declare global {
  interface Window {
    __forceSmoothScrollPolyfill__: boolean;
  }
}
window.__forceSmoothScrollPolyfill__ = true;
smoothscroll.polyfill();

const container = document.getElementById("root");
if (!container) {
  throw new Error("Failed to find the root element");
}

const isErrorPreview =
  typeof window !== "undefined" &&
  (window.location.pathname === "/error-preview" ||
    new URLSearchParams(window.location.search).has("preview=error"));

const root = createRoot(container);
root.render(
  <StyledEngineProvider injectFirst>
    <StylesProvider>
      <ThemeContextProvider initialMode="light">
        <Provider store={store}>
          <React.StrictMode>
            {isErrorPreview ? (
              <ErrorFallback isPreview />
            ) : (
              <ErrorBoundary>
                <App />
              </ErrorBoundary>
            )}
          </React.StrictMode>
        </Provider>
      </ThemeContextProvider>
    </StylesProvider>
  </StyledEngineProvider>
);

serviceWorker.unregister();
